module.exports = {
  "Bass": require("./Bass.json"),
  "BassAmp360": require("./BassAmp360.json"),
  "BassFuzz": require("./BassFuzz.json"),
  "BassFuzz2": require("./BassFuzz2.json"),
  "BassSubDub": require("./BassSubDub.json"),
  "BassSubDub2": require("./BassSubDub2.json"),
  "Brass": require("./Brass.json"),
  "BritBlues": require("./BritBlues.json"),
  "BritBluesDriven": require("./BritBluesDriven.json"),
  "Buzzy1": require("./Buzzy1.json"),
  "Buzzy2": require("./Buzzy2.json"),
  "Celeste": require("./Celeste.json"),
  "ChorusStrings": require("./ChorusStrings.json"),
  "Dissonant1": require("./Dissonant1.json"),
  "Dissonant2": require("./Dissonant2.json"),
  "DissonantPiano": require("./DissonantPiano.json"),
  "DroppedSaw": require("./DroppedSaw.json"),
  "DroppedSquare": require("./DroppedSquare.json"),
  "DynaEPBright": require("./DynaEPBright.json"),
  "DynaEPMed": require("./DynaEPMed.json"),
  "Ethnic33": require("./Ethnic33.json"),
  "Full1": require("./Full1.json"),
  "Full2": require("./Full2.json"),
  "GuitarFuzz": require("./GuitarFuzz.json"),
  "Harsh": require("./Harsh.json"),
  "MklHard": require("./MklHard.json"),
  "Noise": require("./Noise.json"),
  "Organ2": require("./Organ2.json"),
  "Organ3": require("./Organ3.json"),
  "PhonemeAh": require("./PhonemeAh.json"),
  "PhonemeBah": require("./PhonemeBah.json"),
  "PhonemeEe": require("./PhonemeEe.json"),
  "PhonemeO": require("./PhonemeO.json"),
  "PhonemeOoh": require("./PhonemeOoh.json"),
  "PhonemePopAhhhs": require("./PhonemePopAhhhs.json"),
  "Piano": require("./Piano.json"),
  "Pulse": require("./Pulse.json"),
  "PutneyWavering": require("./PutneyWavering.json"),
  "Saw": require("./Saw.json"),
  "Square": require("./Square.json"),
  "TB303Square": require("./TB303Square.json"),
  "Throaty": require("./Throaty.json"),
  "Triangle": require("./Triangle.json"),
  "Trombone": require("./Trombone.json"),
  "TwelveOpTines": require("./TwelveOpTines.json"),
  "TwelveStringGuitar1": require("./TwelveStringGuitar1.json"),
  "WarmSaw": require("./WarmSaw.json"),
  "WarmSquare": require("./WarmSquare.json"),
  "WarmTriangle": require("./WarmTriangle.json"),
  "Wurlitzer": require("./Wurlitzer.json"),
  "Wurlitzer2": require("./Wurlitzer2.json")
};